"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _layout = require("../../layout");

var _text = require("../../text");

var _BoxContainer = _interopRequireDefault(require("./BoxContainer"));

var _core = require("@emotion/core");

var _excluded = ["children", "details", "titleText"];

var DetailedBox = function DetailedBox(_ref) {
  var children = _ref.children,
      details = _ref.details,
      titleText = _ref.titleText,
      boxContainerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_BoxContainer.default, boxContainerProps, (0, _core.jsx)(_layout.View, {
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: "calc(100% - 40px)"
  }, (0, _core.jsx)(_text.Text, {
    fontSize: "T200",
    fontWeight: "medium"
  }, titleText), children), details && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Spacer, {
    height: "S200"
  }), typeof details === 'string' ? (0, _core.jsx)(_text.Text, {
    fontSize: "T100"
  }, details) : (0, _core.jsx)(_layout.View, null, details)));
};

DetailedBox.displayName = 'DetailedBox';
var _default = DetailedBox;
exports.default = _default;